import { Dialog } from '@datacamp/waffles/dialog';
import { Redo } from '@datacamp/waffles/icon';
import { Paragraph } from '@datacamp/waffles/paragraph';
import React, { useCallback } from 'react';

import { useDispatch } from '../../interfaces/State';
import * as actions from '../../redux/actions';

// eslint-disable-next-line @typescript-eslint/ban-types
type Props = {};

const LtiFailure: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const onRetry = useCallback(() => {
    dispatch(actions.removeModal());
    dispatch(actions.retryRequestToLti());
  }, [dispatch]);

  return (
    <>
      <Dialog.Header>Something went wrong...</Dialog.Header>
      <Dialog.Body>
        <Paragraph>
          It seems we weren't able to send your score, but don't worry—your
          progress has been saved. Please try again to continue.
        </Paragraph>
      </Dialog.Body>
      <Dialog.Footer>
        <Dialog.Button
          variant="secondary"
          iconLeft={<Redo />}
          data-cy="lti-retry"
          onClick={onRetry}
        >
          Try again
        </Dialog.Button>
      </Dialog.Footer>
    </>
  );
};

export default LtiFailure;
